import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Router, RouterModule } from '@angular/router';
import { DatePipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

interface DialogData {
	productId: number;
}

@Component({
	selector: 'app-product-redirect-dialog',
	templateUrl: './product-redirect-dialog.component.html',
	styleUrls: ['./product-redirect-dialog.component.scss'],
	imports: [MatDialogModule, RouterModule, MatButtonModule],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductRedirectDialogComponent {
	private readonly router = inject(Router);
	private readonly data: DialogData = inject(MAT_DIALOG_DATA);
	private readonly dialogRef: MatDialogRef<ProductRedirectDialogComponent> = inject(MatDialogRef);
	private readonly datePipe = inject(DatePipe);

	redirect(): void {
		this.closeDialog();
		void this.router.navigate(['/accommodation-file'], {
			queryParams: { products: this.data.productId, date: this.datePipe.transform(new Date(), 'yyyy-MM-dd') },
		});
	}

	closeDialog(): void {
		this.dialogRef.close();
	}
}
